import React from "react";

import { XMarkIcon } from "@heroicons/react/20/solid";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import PropTypes from "prop-types";
import "./Message.less";

import { message } from "./messageUtils";

Message.propTypes = {
  messageKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closable: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

Message.defaultProps = {
  closable: true,
  icon: "info",
};

export default function Message({ messageKey, closable, icon, children }) {
  function getIconDisplay() {
    switch (icon) {
      case "success":
        return <CheckCircleIcon className="w-6 h-6 text-green-600" />;
      case "error":
        return <ExclamationTriangleIcon className="w-6 h-6 text-red-600" />;
      case "info":
        return <InformationCircleIcon className="w-6 h-6 text-blue-600" />;
      case "warning":
      case "warn":
        return <ExclamationCircleIcon className="w-6 h-6 text-yellow-600" />;
      default:
        return icon;
    }
  }

  return (
    <div className="overflow-hidden bg-white rounded-lg shadow-lg pointer-events-auto w-96 ring-1 ring-black ring-opacity-5">
      <div className="p-4">
        <div className="flex items-start">
          <div className="flex-shrink-0">{getIconDisplay()}</div>
          <div className="ml-3 flex-1 pt-0.5">
            <p className="text-sm font-medium text-left text-gray-900">
              {children}
            </p>
          </div>
          {closable && (
            <div className="flex flex-shrink-0 ml-4">
              <button
                className="inline-flex text-gray-400 bg-white rounded-md hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() => message.destroy(messageKey)}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
